// RouteError.jsx
import { useRouteError } from "react-router-dom";

export default function RouteError() {
  const error = useRouteError();
  console.error(error);

  return (
    <div style={{ padding: 40 }}>
      <h2>Something went wrong</h2>
      <p>{error?.message || "Unexpected error"}</p>
      <button onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  );
}
